import React from 'react';
import { getCurrentDate } from '../../utils/dateUtils';

const PaymentModal = ({
  isOpen,
  closeModal,
  student,
  paymentData,
  setPaymentData,
  onSubmit,
  setData
}) => {
  if (!isOpen || !student) return null;

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentData({
      ...paymentData,
      [name]: value
    });
  };

  // Calculate new pending fees based on payment amount
  const calculateNewPendingFees = () => {
    const paymentAmount = parseFloat(paymentData.paymentAmount) || 0;
    const currentPendingFees = parseFloat(student.pendingFees) || 0;
    return Math.max(0, currentPendingFees - paymentAmount).toFixed(2);
  };

  const calculateNewPendingFees2 = () => {
    const paymentAmount = parseFloat(paymentData.paymentAmount) || 0;
    const currentPendingFees = parseFloat(student.pendingFees) || 0;
    const currentPendingFees2 = parseFloat(student.pendingFees2) || 0;
    const remainingPayment = Math.max(0, paymentAmount - currentPendingFees);
    return Math.max(0, currentPendingFees2 - remainingPayment).toFixed(2);
  };

  const calculateNewPendingFees3 = () => {
    const paymentAmount = parseFloat(paymentData.paymentAmount) || 0;
    const currentPendingFees = parseFloat(student.pendingFees) || 0;
    const currentPendingFees2 = parseFloat(student.pendingFees2) || 0;
    const currentPendingFees3 = parseFloat(student.pendingFees3) || 0;
    const remainingPayment = Math.max(0, paymentAmount - currentPendingFees - currentPendingFees2);
    return Math.max(0, currentPendingFees3 - remainingPayment).toFixed(2);
  };

  const calculateNewPendingFees4 = () => {
    const paymentAmount = parseFloat(paymentData.paymentAmount) || 0;
    const currentPendingFees = parseFloat(student.pendingFees) || 0;
    const currentPendingFees2 = parseFloat(student.pendingFees2) || 0;
    const currentPendingFees3 = parseFloat(student.pendingFees3) || 0;
    const currentPendingFees4 = parseFloat(student.pendingFees4) || 0;
    const remainingPayment = Math.max(0, paymentAmount - currentPendingFees - currentPendingFees2 - currentPendingFees3);
    return Math.max(0, currentPendingFees4 - remainingPayment).toFixed(2);
  };

  const shouldShowReferenceField = () => {
    return ['UPI', 'Card Payments', 'Loan'].includes(paymentData.modeOfPayment);
  };

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <div className="payment-modal-header">
          <h2>Record Payment</h2>
          <button className="modal-close-btn" onClick={closeModal}>
            &times;
          </button>
        </div>

        <div className="payment-modal-content">
          {/* Student information section */}
          <div className="payment-field-group">
            <label>Student Name:</label>
            <input type="text" value={student.name || ""} readOnly className="readonly-field" />
          </div>

          <div className="payment-field-group">
            <label>Course:</label>
            <input type="text" value={student.course || ""} readOnly className="readonly-field" />
          </div>

          <div className="payment-field-group">
            <label>Course Fee:</label>
            <input type="text" value={student.courseFees || ""} readOnly className="readonly-field" />
          </div>

          <div className="payment-field-group">
            <label>Fees Collected So Far:</label>
            <input
              type="text"
              value={
                paymentData.paymentAmount
                  ? `${parseFloat(student.feesCollected || 0).toFixed(2)} → ${(parseFloat(student.feesCollected || 0) + parseFloat(paymentData.paymentAmount || 0)).toFixed(2)}`
                  : (student.feesCollected || "0")
              }
              readOnly
              className="readonly-field"
            />
          </div>

          {/* Pending Fees sections */}
          <div className="payment-field-group">
            <label>Pending Fees:</label>
            <input
              type="text"
              value={
                paymentData.paymentAmount
                  ? `${parseFloat(student.pendingFees || 0).toFixed(2)} → ${calculateNewPendingFees()}`
                  : (student.pendingFees || "0")
              }
              readOnly
              className="readonly-field"
            />
          </div>

          {(parseFloat(student.pendingFees2) > 0 ||
            (paymentData.paymentAmount && parseFloat(paymentData.paymentAmount) > parseFloat(student.pendingFees || 0))) && (
              <div className="payment-field-group">
                <label>Pending Fees 2:</label>
                <input
                  type="text"
                  value={
                    paymentData.paymentAmount && parseFloat(paymentData.paymentAmount) > parseFloat(student.pendingFees || 0)
                      ? `${parseFloat(student.pendingFees2 || 0).toFixed(2)} → ${calculateNewPendingFees2()}`
                      : (student.pendingFees2 || "0")
                  }
                  readOnly
                  className="readonly-field"
                />
              </div>
            )}

          {(parseFloat(student.pendingFees3) > 0 ||
            (paymentData.paymentAmount &&
              parseFloat(paymentData.paymentAmount) > parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0))) && (
              <div className="payment-field-group">
                <label>Pending Fees 3:</label>
                <input
                  type="text"
                  value={
                    paymentData.paymentAmount &&
                      parseFloat(paymentData.paymentAmount) > parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0)
                      ? `${parseFloat(student.pendingFees3 || 0).toFixed(2)} → ${calculateNewPendingFees3()}`
                      : (student.pendingFees3 || "0")
                  }
                  readOnly
                  className="readonly-field"
                />
              </div>
            )}

          {(parseFloat(student.pendingFees4) > 0 ||
            (paymentData.paymentAmount &&
              parseFloat(paymentData.paymentAmount) >
              parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0) + parseFloat(student.pendingFees3 || 0))) && (
              <div className="payment-field-group">
                <label>Pending Fees 4:</label>
                <input
                  type="text"
                  value={
                    paymentData.paymentAmount &&
                      parseFloat(paymentData.paymentAmount) >
                      parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0) + parseFloat(student.pendingFees3 || 0)
                      ? `${parseFloat(student.pendingFees4 || 0).toFixed(2)} → ${calculateNewPendingFees4()}`
                      : (student.pendingFees4 || "0")
                  }
                  readOnly
                  className="readonly-field"
                />
              </div>
            )}

          {/* Payment details section */}
          <div className="payment-field-group">
            <label>Payment Amount:</label>
            <input
              type="number"
              name="paymentAmount"
              value={paymentData.paymentAmount}
              onChange={handlePaymentChange}
              placeholder="Enter payment amount"
              min="0"
              max={parseFloat(student.pendingFees) + parseFloat(student.pendingFees2 || 0) + parseFloat(student.pendingFees3 || 0) + parseFloat(student.pendingFees4 || 0)}
              required
              className="editable-field"
            />
          </div>

          <div className="payment-field-group">
            <label>Payment Date:</label>
            <input
              type="date"
              name="paymentDate"
              value={paymentData.paymentDate || getCurrentDate()}
              onChange={handlePaymentChange}
              className="editable-field"
              required
            />
          </div>

          <div className="payment-field-group">
            <label>Mode of Payment:</label>
            <select
              name="modeOfPayment"
              value={paymentData.modeOfPayment}
              onChange={handlePaymentChange}
              required
              className="editable-field"
            >
              <option value="">Select Payment Mode</option>
              <option value="Cash">Cash</option>
              <option value="UPI">UPI</option>
              <option value="Card Payments">Card Payments</option>
              <option value="Loan">Loan</option>
            </select>
          </div>

          {shouldShowReferenceField() && (
            <div className="payment-field-group">
              <label>Transaction Number:</label>
              <input
                type="text"
                name="referenceNo"
                value={paymentData.referenceNo}
                onChange={handlePaymentChange}
                placeholder="Enter reference number"
                className="editable-field"
                required
              />
            </div>
          )}

          {shouldShowReferenceField() && (
            <div className="payment-field-group">
              <label>Bank Details:</label>
              <select
                name="bank"
                value={paymentData.bank}
                onChange={handlePaymentChange}
                className="editable-field"
                required
              >
                <option value="">Choose Bank Details</option>
                <option value="YES Bank - (MMP Br)">YES Bank - (MMP Br)</option>
                <option value="YES Bank - (HOS Br)">YES Bank - (HOS Br)</option>
                <option value="DBS Bank - (BLR Br)">DBS Bank - (BLR Br)</option>
                <option value="HDFC Bank - (CBE Br)">HDFC Bank - (CBE Br)</option>
                <option value="HDFC Bank - (TPR Br)">HDFC Bank - (TPR Br)</option>
                <option value="Icici Bank - (CBE Br)">Icici Bank - (CBE Br)</option>
                <option value="Icici Bank - (TBM Br)">Icici Bank - (TBM Br)</option>
                <option value="Icici Bank - (VCH Br)">Icici Bank - (VCH Br)</option>
                <option value="Icici Bank - (VDP Br)">Icici Bank - (VDP Br)</option>
                <option value="Loan - (Chennai Icici)">Loan - (Chennai Icici)</option>
                <option value="Loan - (CBE HDFC)">Loan - (CBE HDFC)</option>
                <option value="Loan - (HOS YES)">Loan - (HOS YES)</option>
                <option value="YES Bank - (CBE Gpm Br)">YES Bank - (CBE Gpm Br)</option>
                <option value="Kotak Bank - (CBE Gpm Br)">Kotak Bank - (CBE Gpm Br)</option>
                <option value="South Indian Bank - (SRP Ganapathy Br)">South Indian Bank - (SRP Ganapathy Br)</option>
              </select>
            </div>
          )}

          {/* Pending Fees Date fields */}
          {(parseFloat(student.pendingFees) > parseFloat(paymentData.paymentAmount || 0)) && (
            <div className="payment-field-group">
              <label>Pending Fees Date:</label>
              <input
                type="date"
                name="pendingFeesDate"
                value={paymentData.pendingFeesDate || student.pendingFeesDate || ''}
                onChange={handlePaymentChange}
                className="editable-field"
                required
              />
            </div>
          )}

          {(parseFloat(student.pendingFees2 || 0) > 0 &&
            parseFloat(paymentData.paymentAmount || 0) >= parseFloat(student.pendingFees || 0) &&
            parseFloat(paymentData.paymentAmount || 0) < parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0)) && (
              <div className="payment-field-group">
                <label>Pending Fees Date 2:</label>
                <input
                  type="date"
                  name="pendingFeesDate2"
                  value={paymentData.pendingFeesDate2 || student.pendingFeesDate2 || ''}
                  onChange={handlePaymentChange}
                  className="editable-field"
                  required
                />
              </div>
            )}

          {(parseFloat(student.pendingFees3 || 0) > 0 &&
            parseFloat(paymentData.paymentAmount || 0) >= parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0) &&
            parseFloat(paymentData.paymentAmount || 0) < parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0) + parseFloat(student.pendingFees3 || 0)) && (
              <div className="payment-field-group">
                <label>Pending Fees Date 3:</label>
                <input
                  type="date"
                  name="pendingFeesDate3"
                  value={paymentData.pendingFeesDate3 || student.pendingFeesDate3 || ''}
                  onChange={handlePaymentChange}
                  className="editable-field"
                  required
                />
              </div>
            )}

          {(parseFloat(student.pendingFees4 || 0) > 0 &&
            parseFloat(paymentData.paymentAmount || 0) >= parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0) + parseFloat(student.pendingFees3 || 0) &&
            parseFloat(paymentData.paymentAmount || 0) < parseFloat(student.pendingFees || 0) + parseFloat(student.pendingFees2 || 0) + parseFloat(student.pendingFees3 || 0) + parseFloat(student.pendingFees4 || 0)) && (
              <div className="payment-field-group">
                <label>Pending Fees Date 4:</label>
                <input
                  type="date"
                  name="pendingFeesDate4"
                  value={paymentData.pendingFeesDate4 || student.pendingFeesDate4 || ''}
                  onChange={handlePaymentChange}
                  className="editable-field"
                  required
                />
              </div>
            )}
        </div>

        <div className="payment-modal-actions">
          <button className="btn-submit" onClick={onSubmit}>
            Submit
          </button>
          <button className="btn-cancel" onClick={closeModal}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;